import {
  RemixiconComponentType,
  RiChat2Line,
  RiHeartLine,
  RiLayout2Line,
  RiListCheck,
  RiShoppingBag2Line,
  RiStore2Line,
  RiUserSettingsLine,
} from "@remixicon/react";

export interface SidebarItem {
  id: number;
  icon: RemixiconComponentType;
  name: string;
  to: string;
}

export const sidebarListBuyer: SidebarItem[] = [
  {
    id: 1,
    icon: RiShoppingBag2Line,
    name: "Status Pesanan",
    to: "/buyer",
  },
  {
    id: 2,
    icon: RiChat2Line,
    name: "Chat",
    to: "/buyer/chat",
  },
  {
    id: 3,
    icon: RiHeartLine,
    name: "Produk Favorit",
    to: "/buyer/favorite",
  },
  {
    id: 4,
    icon: RiUserSettingsLine,
    name: "Pengaturan Akun",
    to: "/buyer/account",
  },
];

export const sidebarListReseller: SidebarItem[] = [
  {
    id: 1,
    icon: RiLayout2Line,
    name: "Dashboard",
    to: "/reseller",
  },
  {
    id: 2,
    icon: RiShoppingBag2Line,
    name: "Status Pesanan",
    to: "/reseller/order",
  },
  {
    id: 3,
    icon: RiListCheck,
    name: "Supplier",
    to: "/reseller/search/supplier",
  },
  {
    id: 4,
    icon: RiStore2Line,
    name: "Toko Saya",
    to: "/reseller/mystore",
  },
  {
    id: 5,
    icon: RiUserSettingsLine,
    name: "Pengaturan Akun",
    to: "/reseller/account",
  },
];

export const sidebarListSupplier: SidebarItem[] = [
  {
    id: 1,
    icon: RiLayout2Line,
    name: "Dashboard",
    to: "/supplier",
  },
  {
    id: 2,
    icon: RiShoppingBag2Line,
    name: "Status Pesanan",
    to: "/supplier/order",
  },
  {
    id: 3,
    icon: RiStore2Line,
    name: "Toko Saya",
    to: "/supplier/mystore",
  },
  {
    id: 4,
    icon: RiChat2Line,
    name: "Chat",
    to: "/supplier/chat",
  },
  {
    id: 5,
    icon: RiUserSettingsLine,
    name: "Pengaturan Akun",
    to: "/supplier/account",
  },
];

export interface MenuDashboardDrawerInterface {
  label: string;
  href?: string;
  icon?: RemixiconComponentType;
}

export interface NavItemInterface {
  id?: number;
  label: string;
  href?: string;
}

export const publicMenu: NavItemInterface[] = [
  {
    id: 1,
    label: "Masuk",
  },
  {
    id: 2,
    label: "Daftar",
    href: "/register",
  },
  {
    id: 3,
    label: "Beranda",
    href: "/",
  },
  {
    id: 4,
    label: "Produk",
    href: "/product",
  },
  {
    id: 5,
    label: "Blog",
    href: "/blog",
  },
];
